module.exports = __webpack_public_path__ + "static/img/z06.299f2195.png";